import { PanelRightClose, PanelRightOpen } from 'lucide-react';

interface PanelToggleProps {
  open: boolean;
  onToggle: () => void;
  label: string;
  className?: string;
}

export default function PanelToggle({ open, onToggle, label, className }: PanelToggleProps) {
  const Icon = open ? PanelRightClose : PanelRightOpen;
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      aria-pressed={open}
      title={label}
      className={
        'inline-flex h-9 w-9 items-center justify-center rounded-lg ' +
        'bg-bg-elevated border border-border-subtle text-text-secondary ' +
        'hover:text-text-primary hover:border-border-default ' +
        'transition-colors ' +
        (className ?? '')
      }
    >
      <Icon className="w-4 h-4" />
    </button>
  );
}
